// extracted by mini-css-extract-plugin
export var border = "_1g-8";
export var brand = "_1g-t";
export var button = "_1g-l";
export var center = "_1g-a";
export var centered = "_1g-6";
export var closeButton = "_1g-c";
export var disabledWrapper = "_1g-m";
export var error = "_1g-p";
export var extraLarge = "_1g-4";
export var extraSmall = "_1g-1";
export var fill = "_1g-i";
export var footer = "_1g-h";
export var footerAction = "_1g-j";
export var footerButtons = "_1g-k";
export var header = "_1g-7";
export var headerWithClose = "_1g-d";
export var icon = "_1g-o";
export var info = "_1g-s";
export var inline = "_1g-9";
export var large = "_1g-3";
export var main = "_1g-e";
export var modal = "_1g-0";
export var nearFull = "_1g-5";
export var neutral = "_1g-u";
export var noPadding = "_1g-g";
export var none = "_1g-v";
export var scrollable = "_1g-f";
export var small = "_1g-2";
export var success = "_1g-r";
export var tight = "_1g-n";
export var titleIcon = "_1g-b";
export var warn = "_1g-q";